import React, { useMemo } from "react";

import { LeaderboardProviderButton } from "components/wrewards-ui-kit/Button";
import Image from "next/image";
import { TheLeaderboardSourceKeys } from "interfaces";
import styled, { CSSProperties } from "styled-components";
import { PublicLeaderboardProvider } from "types/leaderboard";

const defaultLeaderboardOptions = [
  {
    key: TheLeaderboardSourceKeys.gamdom,
    src: "/images/AllBonuses/provider-logos/gamdom-32.png",
  },
  {
    key: TheLeaderboardSourceKeys.packdraw,
    src: "/images/AllBonuses/provider-logos/packdraw-32.png",
  },
  {
    key: TheLeaderboardSourceKeys.clash,
    src: "/images/AllBonuses/provider-logos/clash-32.png",

    style: {
      position: "relative",
      top: 2,
    },
  },
  {
    key: TheLeaderboardSourceKeys.cases,
    src: "/images/AllBonuses/provider-logos/cases-32.png",
  },
  {
    key: TheLeaderboardSourceKeys.rain,
    src: "/images/AllBonuses/provider-logos/rain.png",

    style: {
      position: "relative",
      top: -3,
    },
  },
  {
    key: TheLeaderboardSourceKeys.luxdrop,
    src: "/images/AllBonuses/provider-logos/luxdrop.png",
  },
  {
    key: TheLeaderboardSourceKeys.hypedrop,
    src: "/images/AllBonuses/provider-logos/hypedrop.svg",
  },
  {
    key: TheLeaderboardSourceKeys.lootbox,
    src: "/images/AllBonuses/provider-logos/lootbox-logo.svg",
  },
  {
    key: TheLeaderboardSourceKeys.wrewards,
    src: "/images/AllBonuses/provider-logos/wrewards-32.png",
  },
  {
    key: TheLeaderboardSourceKeys.datdrop,
    src: "/images/AllBonuses/provider-logos/datdrop.png",
  },
];

type Props = {
  value: string;
  onChange: (v: string) => void;
  leaderboardProviders: PublicLeaderboardProvider[];
  columns?: number;
};

function LeaderboardProviderGridSelector({
  value,
  onChange,
  leaderboardProviders,
  columns,
}: Props) {
  const leaderboardOptions = useMemo(() => {
    return defaultLeaderboardOptions.filter((lbProvider) =>
      leaderboardProviders.some((lbOption) => lbOption.providerName === lbProvider.key)
    );
  }, [leaderboardProviders]);

  return (
    <LeaderboardProviderGrid $columns={columns}>
      {leaderboardOptions.map(({ key, src, style }) => {
        return (
          <LeaderboardProviderButton
            key={key}
            $active={key === value}
            onClick={() => onChange(key)}
            type="button"
          >
            <LeaderboardProviderLogo style={style as CSSProperties}>
              <Image fill src={src} alt="" style={{ objectFit: "contain" }} />
            </LeaderboardProviderLogo>
          </LeaderboardProviderButton>
        );
      })}
    </LeaderboardProviderGrid>
  );
}

export default LeaderboardProviderGridSelector;

export const LeaderboardProviderGrid = styled.div<{ $columns?: number }>`
  width: 100%;
  display: grid;
  ${({ $columns }) =>
    $columns
      ? `
        grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
      `
      : `
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      `}
  gap: clamp(8px, 1.2vw, 12px);
  margin-bottom: 20px;
`;

const LeaderboardProviderLogo = styled.div`
  position: relative;
  width: 100%;
  height: clamp(22px, 4vw, 44px);
  max-width: clamp(70px, 16vw, 140px);
`;
